

export class Download {
    public app: string;
    public platform: string;
    public title: string;
    constructor() {}
}
